import WorldMapImage from '@/assets/imgs/world-map.webp'
import {
  fadeLeft,
  fadeRight,
  staggerContainer,
} from '@/core/constants/animations'
import { Motion } from '@/core/ui/atoms/motion'
import { getTranslations } from 'next-intl/server'
import Image from 'next/image'

type CardProp = {
  className?: string
  dir?: 'left' | 'right'
  children: React.ReactNode
  motionProps?: React.ComponentProps<typeof Motion>
}

const MapCard: React.FC<CardProp> = ({
  className,
  dir = 'left',
  children,
  motionProps,
}) => (
  <Motion
    type='div'
    {...motionProps}
    initial='initial'
    whileInView='animate'
    viewport={{ once: true }}
    className={`bg-grey-2 absolute hidden rounded-lg p-5 after:absolute after:bottom-0 after:z-0 after:block after:h-6 after:w-6 after:translate-y-1/2 after:rounded-lg after:bg-inherit lg:block lg:w-72 ${className} ${
      dir === 'left'
        ? 'shadow-pale-blue shadow-md after:left-6 after:[clip-path:polygon(100%_50%,0_100%,0_0)]'
        : 'shadow-pale-blue shadow-md after:right-0 after:[clip-path:polygon(0_50%,100%_100%,100%_0)]'
    }`}
  >
    {children}
  </Motion>
)

export const WorldMap = async () => {
  const t = await getTranslations()

  return (
    <Motion
      type='div'
      className='relative self-center'
      variants={staggerContainer}
      initial='initial'
      whileInView='animate'
      viewport={{ once: true, amount: 0.3 }}
    >
      <Image
        src={WorldMapImage}
        width={1024}
        height={600}
        className='w-full md:w-auto'
        alt='World map showing FlatLane destinations'
      />

      <MapCard
        dir='right'
        className='top-0 left-0'
        motionProps={{
          variants: fadeRight.variants,
          transition: fadeRight.transition,
        }}
      >
        {t('map.enjoy')}
      </MapCard>

      <MapCard
        dir='left'
        className='top-32 right-0'
        motionProps={{
          variants: fadeLeft.variants,
          transition: fadeLeft.transition,
        }}
      >
        {t('map.samePrices')}
      </MapCard>
    </Motion>
  )
}
